/**
 * @FileDescription: 工单-服务类型
 * @Author: liujianing
 * @Date: 2021-11-09
 * @LastEditors: liujianing
 * @LastEditTime: 2021-11-09
 */
// import axios from "@/api/utils/axios";
import BaseApi from "@/api/utils/baseApi.js";

const OrderTypeApi = {
  /**
   * @description: 基础地址
   */
  baseUrl: function () {
    return "/longstron/workorder/service/define";
  },
};

export default Object.assign(OrderTypeApi, BaseApi);
